import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typePromoColor'
})
export class TypePromoColorPipe implements PipeTransform {

  transform = (value: string): string => {
    let color = '';
    switch (value) {
      case 'DINAMICO':
        color = 'danger';
        break;
      case 'ESCALERA':
        color = 'stairs';
        break;
      case 'ESTATICO':
        color = 'sunflower';
        break;
      case 'BONIFICACION':
        color = 'pink';
        break;
      case 'SUNDAY':
        color = 'default'
        break;
    }

    return color;
  }

}
